import symbolUrl from "../../../brand/topzle-symbol-ui.png";

export function BrandMark({ className = "mark" }: { className?: string }) {
  return <img className={className} src={symbolUrl} alt="" aria-hidden="true" />;
}
